import { Center, CenterProps } from "styled-system/jsx";
import { useEventsWidgetContext } from "../EventsContext";
import { eventMessageCardRecipe } from "./recipe";
import { Text } from "@ttc3k/trekker";

type EventMessageCardProps = {
  text: string;
} & CenterProps;

export const EventMessageCard = ({ text, ...props }: EventMessageCardProps) => {
  const { widgetSize } = useEventsWidgetContext();
  const classes = eventMessageCardRecipe({ size: widgetSize });

  return (
    <Center className={classes.container} {...props}>
      <Text
        part="events__month-skipped-text"
        visual="bodyRegular"
        className={classes.text}
      >
        {text}
      </Text>
    </Center>
  );
};
